import React from "react";

import { useParams } from "../../../generic/routing";
import type { NOTIFICATIONS_PATH } from "../../Routes";

import { NotificationsAddBreadcrumb } from "./NotificationsAddBreadcrumb";
import { NotificationsIndexBreadcrumb } from "./NotificationsIndexBreadcrumb";
import { NotificationsNamedBreadcrumb } from "./NotificationsNamedBreadcrumb";

export const NotificationsBreadcrumb: React.FC = () => {
	const { id } = useParams<typeof NOTIFICATIONS_PATH>();

	return (
		<>
			<NotificationsIndexBreadcrumb />
			{id === "new" && <NotificationsAddBreadcrumb />}
			{id !== "new" && id != null && <NotificationsNamedBreadcrumb id={id} />}
		</>
	);
};
